import addToCart from '../lib/addToCart';
import { SELECTORS } from '../utils/constants';
import updateCart from '../lib/updateCart';
import toggleAtcNotification from '../lib/toggleAtcNotification';

const initAtcForm = () => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.id.value;
    const quantityInput = form.querySelector('[data-quantity-input]') || form.querySelector('input[name="quantity"]');
    let quantity = 1;
    if (quantityInput && quantityInput.value) {
      quantity = Math.max(1, +quantityInput.value || 1);
    }

    const sellingPlanEl = form.elements['selling_plan'];
    const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;

    return [variantId, quantity, sellingPlan];
  };

  const getAdditionalItem = (activeVariantEl) => {
    const additionalProductId = +activeVariantEl.getAttribute('data-additional-product-id');
    const quantity = 1;
    let additionalSellingPlan = null;
    if (activeVariantEl.hasAttribute('data-additional-selling-plan-id')) {
      additionalSellingPlan = +activeVariantEl.getAttribute('data-additional-selling-plan-id');
    } else {
      additionalSellingPlan = null;
    }

    return [additionalProductId, quantity, additionalSellingPlan];
  };

  const getAttributes = (form) => { 
    const attributeInputs = form.querySelectorAll('input[name^="attributes["]');
    const attributes = {};

    attributeInputs.forEach((input) => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match) {
        const key = match[1];
        attributes[key] = input.value;
      }
    });
    return attributes;
  };

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity, sellingPlan] = getItem(evt.target);
      let addedProduct;
      const activeVariantEl = evt.target.querySelector('[data-active-variant]');
      if (activeVariantEl) {
        if (activeVariantEl.hasAttribute('data-additional-product-id')) {
          const [additionalProductId, additionalQuantity, additionalSellingPlan] = getAdditionalItem(activeVariantEl);
          addedProduct = await addToCart([
            { id: variantId, quantity: quantity, sellingPlan: sellingPlan },
            { id: additionalProductId, quantity: additionalQuantity, sellingPlan: additionalSellingPlan }
          ]);
        } else {
          addedProduct = await addToCart([{id: variantId, quantity: quantity, sellingPlan: sellingPlan}]);
        }
      } else {
        addedProduct = await addToCart([{id: variantId, quantity: quantity, sellingPlan: sellingPlan}]);
      }
      
      const attributes = getAttributes(evt.target);
      if (attributes) {
        await updateCart(attributes);
      }
      toggleAtcNotification(addedProduct);
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
